export function getDurationInHoursAndMinutes(
  nbOfMinutes: number,
  options?: {
    leadingZero?: boolean;
    short?: boolean;
    noMinuteSuffixWhenHours?: boolean;
  },
): string {
  const minuteLabel = options?.short ? 'm' : 'min';
  const nbOfHours = Math.floor(nbOfMinutes / 60);
  const remainingMinuts = Math.floor(nbOfMinutes - nbOfHours * 60);

  if (nbOfHours === 0) {
    return `${remainingMinuts}${minuteLabel}`;
  }

  const minuteSuffix = options?.noMinuteSuffixWhenHours ? '' : minuteLabel;

  if (remainingMinuts === 0) {
    if (options?.leadingZero) {
      return `${nbOfHours}h00${minuteSuffix}`;
    }
    return `${nbOfHours}h`;
  }
  if (remainingMinuts < 10) {
    return `${nbOfHours}h0${remainingMinuts}${minuteSuffix}`;
  }
  return `${nbOfHours}h${remainingMinuts}${minuteSuffix}`;
}
